import semver from 'semver';

export const hasAnUpdateAvailable = (latestVersion, currentVersion) => {
  // Both versions must be valid semver to compare
  if (!semver.valid(latestVersion) || !semver.valid(currentVersion)) {
    return false;
  }
  return semver.lt(currentVersion, latestVersion);
};
